<div class="modal-header">
  <button
    type="button"
    class="close"
    ng-click="$close()"
  >
    &times;
  </button>
  <h4 class="modal-title">Comparativo planejado/aplicado</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-6">
      <h5 class="text-center">Planejado</h5>
      <p>
        Data: {{$ctrl.parameter.data_estimada | date: 'dd/MM'}}
      </p>
      <p>
        Area: {{$ctrl.parameter.area | number}}/ha
      </p>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Produto</th>
            <th>Dose</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="produto in $ctrl.parameter.recomendacao.insumos | orderBy: 'descricao' track by produto.id">
            <td>{{produto.descricao}}</td>
            <td>{{+produto.dose | number:3}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}/ha</td>
            <td>{{+produto.dose * (+$ctrl.parameter.area || +produto.total_area) | number:3}}{{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <span ng-repeat="aplicacao in $ctrl.parameter.applications">
      <div class="col-xs-6">
        <h5 class="text-center">
          Aplicado
          <button class="close" uib-tooltip="Desvincluar aplicação" tooltip-placement="left" ng-click="$ctrl.desvincular(aplicacao)">
            <i class="fa fa-unlink"></i>
          </button>
          <p>

        </h5>
          Data: {{aplicacao.dt_ini | date: 'dd/MM'}}
        </p>
        <p>
          Area: {{aplicacao.area | number}}/ha
        </p>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Produto</th>
              <th>Dose</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="produto in aplicacao.itens | orderBy: 'descricao' track by produto.id">
              <td>{{produto.descricao}}</td>
              <td>{{produto.qt_dose | number:3}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}/ha</td>
              <td>{{produto.qt_total | number:3}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}</td>
            </tr>
          </tbody>
        </table>
        <div class="modal-footer text-muted">
          <small>
            <a ng-href="#!/propriedade?sidebar=applications&activeApplication={{aplicacao.id}}">
              Detalhes da aplicação</a>
          </small>
        </div>
      </div>
    </span>
  </div>
</div>
